// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const OriginalSubmissionDateCriteria = props => {

    const range = new DateRange({
        from: props.dateRange.from,
        to: props.dateRange.to
    });

    return (

        <section className='original-submission-date-criteria form-group'>
            <label className='form-group-title'>
                <FormattedMessage id={props.label}/>
            </label>
            <WarrantyDateRangePicker
                dateRange={range}
                maxDate={props.dateRange.max}
                minDate={props.dateRange.min}
                onDateChange={props.onDateChange}
            />
        </section>

    );

};

OriginalSubmissionDateCriteria.displayName = 'OriginalSubmissionDateCriteria';
OriginalSubmissionDateCriteria.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default OriginalSubmissionDateCriteria;




// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report-criteria/date-criteria.js